<template>
    <div class="flex items-center">
        <div>
            <div class="flex row q-pl-md q-pr-md bg-color-white">
                <div class=" text-left text-h6 col-3 q-mb-xs" style="width: 100%;">基本信息</div>
                <div class="flex row q-gutter-y-xs text-color">
                    <div class="flex row items-center text-body2 col-md-3 col-xs-4 ">
                        <div class="q-mr-sm text-title-color">客户名称:</div>
                        <div>{{custom_name}}</div>
                    </div>
                    <div class="flex row items-center text-body2 col-md-3">
                        <div class="q-mr-sm text-title-color ">项目名称:</div>
                        <div>{{project_name}}</div>
                    </div>
                    <!--                    <div class="flex row items-center text-body2">-->
                    <!--                        <div class="q-mr-sm">所属区域:</div>-->
                    <!--                        <div>{{area}}</div>-->
                    <!--                    </div>-->
                    <div class="flex row items-center text-body2 col-md-3 col-xs-4">
                        <div class="q-mr-sm text-title-color">详细地址:</div>
                        <div>{{project_address}}</div>
                    </div>
                    <div class="flex row items-center text-body2 col-md-3 col-xs-4">
                        <div class="q-mr-sm text-title-color">项目阶段:</div>
                        <div>{{zhuangxiu_progress}}</div>
                    </div>
                    <div class="flex row items-center text-body2 col-md-3 col-xs-4">
                        <div class="q-mr-sm text-title-color">建筑面积:</div>
                        <div>{{jianzhu_mianji}}</div>
                    </div>
                    <div class="flex row items-center text-body2 col-md-3 col-xs-4">
                        <div class="q-mr-sm text-title-color">套内面积:</div>
                        <div>{{taonei_mianji}}</div>
                    </div>
                    <div class="flex row items-center text-body2 col-md-3 col-xs-4">
                        <div class="q-mr-sm text-title-color">房屋结构:</div>
                        <div>{{fangjian_jiegou}}</div>
                    </div>
                    <!--                    <div class="flex row items-center text-body2">-->
                    <!--                        <div class="q-mr-sm text-title-color">经销商:</div>-->
                    <!--                        <div>{{dealer}}</div>-->
                    <!--                    </div>-->
                    <div class="flex row items-center text-body2 col-md-3 col-xs-4">
                        <div class="q-mr-sm text-title-color">C端客户:</div>
                        <div>{{c_custom_name}}</div>
                    </div>
                    <div class="flex row items-center text-body2 col-md-3 col-xs-4">
                        <div class="q-mr-sm text-title-color">C端客户电话:</div>
                        <div>{{c_custom_phone}}</div>
                    </div>
                    <div class="flex row items-center text-body2 col-md-3 col-xs-4">
                        <div class="q-mr-sm text-title-color">销售负责人:</div>
                        <div>{{charge_name}}</div>
                    </div>
<!--                    <div class="flex row items-center text-body2 col-md-3 col-xs-4">-->
<!--                        <div class="q-mr-sm text-title-color">负责人电话:</div>-->
<!--                        <div>{{chargePhone}}</div>-->
<!--                    </div>-->
                    <div class="flex row items-center text-body2 col-md-3 col-xs-4">
                        <div class="q-mr-sm text-title-color">提交日期:</div>
                        <div>{{apply_date}}</div>
                    </div>
                    <div class="flex row items-center text-body2 col-md-3 col-xs-4">
                        <div class="q-mr-sm text-title-color">使用喜好:</div>
                        <div>{{shiyong_xihao}}</div>
                    </div>
                </div>

            </div>
            <div class="q-mt-md bg-color-white q-pa-md text-left text-color">
                <div class="row q-gutter-x-md items-center">
                    <div class="text-h6">时效信息</div>
<!--                    <div class="text-body2">总用时：{{totalTime}}</div>-->
                    <div class="text-body2">总用时：-- </div>
                </div>
<!--                <div class="q-mt-lg" style="height: 500px;">-->

<!--                    <el-timeline>-->
<!--                        <el-timeline-item-->
<!--                                v-for="(activity, index) in activities"-->
<!--                                :key="index"-->
<!--                                :timestamp="activity.timestamp">-->
<!--                            {{activity.content}}-->
<!--                        </el-timeline-item>-->
<!--                    </el-timeline>-->
<!--                </div>-->
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        // 管理主页
        data() {
            return {
                taonei_mianji: '',
                shiyong_xihao: '',
                fangjian_jiegou: '',
                jianzhu_mianji: '',
                project_name: '',
                project_hash: '',
                zhuangxiu_progress: '',
                dealer: '',//经销商
                c_custom_name: '',//C端客户
                charge_name: '',// 负责人
                apply_date: '',//时间
                custom_name: '',//客户名称
                c_custom_phone: '',
                project_address: '',
                totalTime: '1天4小时25分钟',
                activities: [
                    {
                        content: '提交视频讲解',
                        timestamp: '2018-04-15'
                    }, {
                        content: '提交方案配置',
                        timestamp: '2018-04-13'
                    }, {
                        content: '分配方案项目负责人',
                        timestamp: '2018-04-11'
                    },
                    {
                        content: '申请方案配置',
                        timestamp: '2018-04-15'
                    }, {
                        content: '分配销售区域',
                        timestamp: '2018-04-13'
                    }, {
                        content: '新建需求',
                        timestamp: '2018-04-11'
                    }]
            }
        },
        created() {
            this.project_hash = this.$route.params.project_hash
            console.log(this.project_hash)
            this.homePageData({project_hash: this.project_hash});
        },
        methods: {
            // 请求数据
            homePageData(params) {
                // 请求数据成功在返回
                this.$http({
                    url: 'manage_project_view',
                    data: params
                }).then((res)=>{
                    console.log(res)
                    this.shiyong_xihao = res.data.project_info.shiyong_xihao;
                    this.fangjian_jiegou = res.data.project_info.fangjian_jiegou;
                    this.jianzhu_mianji = res.data.project_info.jianzhu_mianji;
                    this.project_name = res.data.project_info.project_name;
                    this.zhuangxiu_progress = res.data.project_info.zhuangxiu_progress;
                    this.c_custom_name = res.data.project_info.c_custom_name;
                    this.charge_name = res.data.project_info.charge_name;
                    this.apply_date = res.data.project_info.apply_date;
                    this.custom_name = res.data.project_info.custom_name;
                    this.c_custom_phone = res.data.project_info.c_custom_phone
                    this.project_address = res.data.project_info.project_address;
                    this.taonei_mianji = res.data.project_info.taonei_mianji;
                }).catch((err)=>{

                    console.log(err)
                })
            },
            // 操作
            handleOperating(e) {
                console.log(e)
                var typeValue = parseInt(e.type);
                switch (typeValue) {
                    case 0:
                        this.$router.push({name: 'detail', params: {title: '详情'}})
                        break
                    default:
                        break;
                }
            },
            // 变更状态
            handleChangeCommand(e) {
                console.log(e)
            },
            // 变更费用
            handleCostCommand(e) {
                console.log(e)
            },
            // 查询
            handleInquireCommand() {
                console.log('查询')
            },
            composeValue(type, row) {
                return {
                    type: type,
                    row: row
                }
            },
        }
    }
</script>

<style scoped>
.text-title-color{
    color: #666666;
}
    .text-color{
        color: #333333;
    }
</style>
